<form (ngSubmit)="lagre()" [formGroup]="skjema" class="e2e-inviter-medlem-skjema" #skjemaelement>
  <inline-skjema>
    <inline-skjema-tittel>{{'Inviter nytt medlem' | translate}}</inline-skjema-tittel>

    <div class="nyttmedlem-kontainer">
      <i class="nyttmedlem-markør ion-ios-plus-outline" (click)="giFokusTilNyttMedlemFelt()"></i>
      <medlem-invitasjon-skjema [skjema]="skjema.controls.invitasjon"/>
      <mat-slide-toggle [formControl]="skjema.controls.oppdaterMoetemal"
                        class="oppdater-moetemal e2e-oppdaterMoetemal"
                        matTooltip="{{'Medlemmer uten tilgang til ikke-publisert informasjon vil ikke kunne se møte- og saksdetaljer for ikke-publisert møte'|translate}}">
        {{ 'Skal som hovedregel delta i møtene'|translate }}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="skjema.controls.skalSignereSomStandard"
                        class="skal-signere-som-standard e2e-skalSignereSomStandard"
                        matTooltip="{{'Fører til at gruppemedlemmet blir lagt til i møtemal og alle fremtidige møter som signatar'|translate}}">
        {{ 'Skal som hovedregel signere protokoller/referater'|translate }}
      </mat-slide-toggle>
    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <div class="handlinger-samling">
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()"
              [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Registrerer...'|translate}}">
        {{ "Registrer"|translate }}
      </button>
      <button mat-stroked-button type="button" (click)="avbryt()">
        {{ "Avbryt"|translate }}
      </button>

      <mat-slide-toggle [formControl]="skjema.controls.sendInvitasjon" data-testid="send-invitasjonsepost"
                        matTooltip="{{'Skru av denne dersom du ikke ønsker at systemet sender en e-post med invitasjon'|translate}}">
        {{'Send invitasjons-e-post'|translate}}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="skjema.controls.sendInnkallingTilMoeter" data-testid="send-innkalling-til-moeter-epost"
                        matTooltip="{{'Skru av denne dersom du ikke ønsker å sende innkalling til møter nå'|translate}}">
        @if (antallMoeterDetSkalSendesInnkallingTilMoeter() == 1) {
          {{ 'Send innkalling til 1 møte'|translate }}
        } @else {
          {{ 'Send innkalling til {antallMoter} møter'|translate: {antallMoter: antallMoeterDetSkalSendesInnkallingTilMoeter()} }}
        }
      </mat-slide-toggle>
      </div>

      <button mat-stroked-button type="button" (click)="visImporterMedlemmerDialog()"
              matTooltip="{{'Importer multiple medlemmer i en operasjon, enten fra regneark eller fra en annen gruppe'|translate}}">
        {{ "Importer"|translate }}
      </button>

    </inline-skjema-handlinger>
  </inline-skjema>
</form>
